import React from "react";
import ReactModal from "react-modal";
import { Input, Draggable, Select, Pagination } from "@components";
import { FormProvider } from "react-hook-form";
import { useCompanyLogic } from "@hooks";
import { useAdminCompany } from "@context";

function CompanySearchModal({ isOpen, onClose, onConfirm, showAllOption = false }) {
  const { adminCompCode, setAdminCompCode, setAdminCompName } = useAdminCompany();  // 전역 선택한 사업장 코드, 이름 세팅(관리자일때만)

  const position = Draggable({
    isOpen,
    dragHandle: ".modal-header",
  });

  const containerStyle = {
    maxWidth: "1300px",
    minWidth: "1300px",
    maxHeight: "85vh",
    minHeight: "500px",
    transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px)`
  };

  const {
    methods,
    data,
    handleSubmit, 
    onSubmit,   
    handlePageChange,
    pageIndex,
  } = useCompanyLogic();

  const onRowClick = (compCode) => {
    const selected = data.resultList.find((company) => company.compCode === compCode);
    onConfirm(selected);
    setAdminCompCode(selected.compCode);
    setAdminCompName(selected.compName);
    onClose();
  };

  const handleSelectAll = (e) => {
    e.preventDefault();
    const allCompany = { compCode: "", compName: "" };
    onConfirm(allCompany);
    setAdminCompCode("");
    setAdminCompName("");
    onClose();
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="modal-overlay2"
      className="modal-wrap"
    >
      <div className="modal-container" style={containerStyle}>
          <div className="modal-header"  style={{ cursor: "move" }}>
            <h5>회사 선택</h5>
            <button type="button" className="modal-btn-close" onClick={onClose}>
              <span className="modal-btn-span">X</span>
            </button>
          </div>
        <FormProvider {...methods}>  
        <div className="modal-content">
          <div className="search-wrap">
            <div className="search-row">
              <div className="search-item">
                <Select
                  name="searchCnd"
                  options={[
                    { key: "0", name: "회사" },
                    { key: "1", name: "대표" },
                    { key: "2", name: "주소" },
                  ]}
                  defaultOption="선택"
                  className="input-select"
                />
                <Input
                  name="searchWrd"
                  placeholder="검색어를 입력하세요"
                  className="input-search"
                  style={{ width: "250px" }}
                />
              </div>
              <div className="search-btn-container">
                <button type="button" className="btn-search" onClick={handleSubmit(onSubmit)} >조회</button>
              </div>
            </div>
          </div>
            <div className="modal-table-list overflow-x-auto table-list-wrapper">
            <table className="table-list" style={{ width: "100%" }}>
              <colgroup>
                <col style={{ width: "15%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "20%" }} />
                <col style={{ width: "20%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th>사업자번호</th>
                  <th>회사</th>
                  <th>대표</th>
                  <th>주소</th>
                </tr>
              </thead>
              <tbody>
              {data?.resultList && data.resultList.length > 0 ? (
                    data.resultList.map((item) => (
                        <tr
                          key={item.compCode}
                          onClick={() => onRowClick(item.compCode)}
                          style={{ cursor: "pointer" }}
                        >
                          <td style={{textAlign:"left"}}>{item.bizNo}</td>
                          <td style={{textAlign:"left"}}>{item.compName}</td>
                          <td>{item.repName}</td>
                          <td style={{textAlign:"left"}}>{item.addr1}</td>
                        </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="table-empty" style={{ textAlign: "center" }}>
                        조회 결과가 없습니다.
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>
          {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
            <Pagination
                totalPages={Math.ceil(
                data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                )}
                currentPage={pageIndex}
                onPageChange={handlePageChange}
                pageRangeDisplayed={5}
            />
          )}
        </div>

        </FormProvider>
        <div className="modal-btn-wrap btn-right-box" style={{marginTop:'20px'}}>
            <ul>
                {showAllOption && (
                  <li><button type="button" className="btn-save" onClick={handleSelectAll}>조회</button></li>
                )}
                <li><button type="button" className="btn-cancel" onClick={onClose}>취소</button></li>
            </ul>
        </div>
      </div>
    </ReactModal>
  );
}

export {CompanySearchModal};

